<template src="@/templates/document/resources.html"></template>

<script>
import ResourceCollection from "@/collections/resourceCollection";
import ResourceCategoryCollection from "@/collections/resourceCategoryCollection";
import ResourceModel from "@/models/resourceModel";
import fileView from "@/components/file/FileView";
import { mapActions } from "vuex";

export default {
  name: "resources",
  props: ["type_id"],
  components: {
    fileView,
  },
  watch: {
    $route: {
      handler: function () {
        this.resource_type_id = this.type_id;
        this.fetchResources();
        this.fetchCategories();
      },
      deep: true,
    },
  },
  data() {
    return {
      resourceCollection: new ResourceCollection(),
      resourceCategoryCollection: new ResourceCategoryCollection(),
      resourceModel: new ResourceModel(),
      resourceTitle: "Resources",
      viewFileViewComp: false,
      currentFileName: "",
      isThis: "resources",
      resource_type_id: 0,
      category_id: 0,
    };
  },
  created() {
    console.log("resources triggered");
    Event.$emit("hideCheckViewPopUp");

    this.resource_type_id = this.type_id;

    this.updateIcon(["search", "", ""]);
    this.updateResourceCategory(true);
    this.updateClockOnOffHide(true);
    this.updateAcceptDeclineHide(true);
    this.updateSearchStateHide(true);
    this.updateCameraStateHide(true);
    this.updateResourceCategoryHide(false);
    this.updateBackButton(false);

    this.fetchResources();
    this.fetchCategories();
  },
  mounted() {
    Event.$on("hideFileViewComp", (isThis) => {
      if (isThis === this.isThis) {
        let thisComponent = this;
        setTimeout(function () {
          thisComponent.viewFileViewComp = false;
        }, 50);
      }
    });

    Event.$on("refreshCheck", () => {
      this.fetchResources();
    });

    Event.$on("filterResourceListByCategory", (categoryID) => {
      console.log(categoryID);
      this.fetchResources(categoryID);
    });
  },
  methods: {
    ...mapActions([
      "updateIcon",
      "updateCameraState",
      "updateClockOnOffHide",
      "updateAcceptDeclineHide",
      "updateSearchStateHide",
      "updateCameraStateHide",
      "updateBackButton",
      "updateResourceCategoryHide",
      "updateResourceCategory",
    ]),
    fetchResources(categoryID = 0) {
      this.resourceCollection
        .getList(this.resource_type_id, categoryID)
        .then((resourceCollectionRes) => {
          this.resourceCollection.models =
            resourceCollectionRes.response.data.data;
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    fetchCategories() {
      console.log("fetch categories");

      this.resourceCategoryCollection
        .getList(this.resource_type_id, this.category_id)
        .then((categoryCollectionRes) => {
          this.resourceCategoryCollection.models =
            categoryCollectionRes.response.data.data;

          console.log(this.resourceCategoryCollection.models);

          Event.$emit(
            "resourceCategoryList",
            this.resourceCategoryCollection.models
          );
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    viewResourcePage(model) {
      this.currentFileName = model.file_name;
      this.viewFileViewComp = true;
    },
    getResourceDetails(model, routeName) {
      this.resourceModel.data.interpreter_resource_id =
        model.interpreter_resource_id;

      this.resourceModel
        .saveAsReadSeen()
        .then(() => {
          this.$router.push({
            path:
              "/resourceDetail/" +
              model.interpreter_resource_id +
              "/" +
              routeName +
              "/" +
              this.resource_type_id,
          });
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    getThumbnail(model) {
      return (
        this.$interpretersApiUrl +
        this.resourceModel.getRoute("view") +
        localStorage.getItem("jwt") +
        "&irID=" +
        model.interpreter_resource_id
      );
    },
  },
};
</script>

<style scoped>
.badge {
  color: white;
  background-color: #f57e21;
}
</style>
